export enum PopoverPositionEnum {
  TOP_LEFT_UP = 'TOP_LEFT_UP', // makes the popover open upwards from top-left corner of the origin
  TOP_RIGHT_UP = 'TOP_RIGHT_UP', // makes the popover open upwards from top-left corner of the origin
  BOTTOM_LEFT_DOWN = 'BOTTOM_LEFT_DOWN', // makes the popover open downwards from the bottom-left corner of the origin
  BOTTOM_RIGHT_DOWN = 'BOTTOM_RIGHT_DOWN', // makes the popover open downwards from the bottom-right corner of the origin
}
